export default __webpack_public_path__ + "static/media/tiktok.688d02df.svg";